import { api } from './api';

export type VideoMockupStatus = 'created' | 'queueing' | 'processing' | 'success' | 'failed';
export type VideoMockupModel = 'viduq3-turbo' | 'viduq3-pro';
export type VideoMockupResolution = '720p' | '1080p';

export interface VideoMockup {
  id: string;
  user_id: string;
  source_mockup_id: string | null;
  name: string;
  provider: string;
  task_id: string | null;
  status: VideoMockupStatus;
  provider_state: string | null;
  prompt: string | null;
  model: VideoMockupModel;
  duration: number;
  resolution: VideoMockupResolution;
  video_url: string | null;
  thumbnail_url: string | null;
  error_message: string | null;
  settings: Record<string, any> | null;
  created_at: string;
  updated_at: string;
}

export interface CreateVideoMockupRequest {
  sourceMockupId: string;
  name?: string;
  prompt: string;
  model: VideoMockupModel;
  duration: number;
  resolution: VideoMockupResolution;
}

class VideoMockupService {
  async list() {
    const response = await api.get<{ videoMockups: VideoMockup[] }>('/api/video-mockups');
    return response.data.videoMockups || [];
  }

  async create(request: CreateVideoMockupRequest) {
    const response = await api.post<{ videoMockup: VideoMockup }>('/api/video-mockups', request);
    return response.data.videoMockup;
  }

  async get(id: string) {
    const response = await api.get<{ videoMockup: VideoMockup }>(`/api/video-mockups/${id}`);
    return response.data.videoMockup;
  }

  async refresh(id: string) {
    const response = await api.post<{ videoMockup: VideoMockup }>(`/api/video-mockups/${id}/refresh`);
    return response.data.videoMockup;
  }

  async remove(id: string) {
    await api.delete(`/api/video-mockups/${id}`);
  }

  async download(videoMockup: VideoMockup) {
    const response = await api.get(`/api/video-mockups/${videoMockup.id}/download`, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'video/mp4' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${videoMockup.name.replace(/\s+/g, '-').toLowerCase() || 'video-mockup'}.mp4`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export const videoMockupService = new VideoMockupService();
